import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Background = class Background extends Vue {
    constructor() {
        super(...arguments);
        this.url = "";
    }
    get style() {
        return `background-image: url('${this.url}')`;
    }
    created() {
        if (this.custom) {
            this.url = this.$store.state.customBackgroundURL;
        }
    }
};
__decorate([
    Prop({ default: false })
], Background.prototype, "custom", void 0);
Background = __decorate([
    Component
], Background);
export default Background;
